import { browseCoursesActions } from './browseCoursesSlice'
import { fetchCachedHelper } from '../../../api/api'

export const getCourses = params => async dispatch => {
    dispatch(browseCoursesActions.getCoursesRequest())
    try {
        const response = await fetchCachedHelper(`Course`, {
            params,
        })
        let { data: courses, paging } = response.data
        courses = courses.map((course, idx) => ({
            ...course,
        }))
        dispatch(
            browseCoursesActions.getCoursesRequestSuccess({ courses, paging })
        )
    } catch (e) {
        dispatch(browseCoursesActions.getCoursesRequestError(e.message))
    }
}
